import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { TFeatureFlagValue } from '../constants/featureFlagConstants';

interface IFeatureFlagDevOverridesStore {
	devOverrides: Record<string, TFeatureFlagValue>;
	setOverride: (flagKey: string, value: TFeatureFlagValue) => void;
	resetOverrides: () => void;
}

const initialState: Pick<IFeatureFlagDevOverridesStore, 'devOverrides'> = {
	devOverrides: {},
};

export const useFeatureFlagDevOverridesStore =
	create<IFeatureFlagDevOverridesStore>()(
		persist(
			(set) => ({
				...initialState,
				setOverride: (flagKey, value) =>
					set((state) => ({
						devOverrides: { ...state.devOverrides, [flagKey]: value },
					})),
				resetOverrides: () => set(initialState),
			}),
			{ name: 'featureFlagDevOverrides' }
		)
	);
